import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      "fill-rule": "evenodd",
      d: "M12.538 3.466a1.39 1.39 0 0 0-1.076 0l-7.04 2.959 2.915 1.224 7.577-3.184zM16.663 5.2 9.087 8.385 12 9.609l7.577-3.184zm3.99 2.243-7.98 3.355v9.505l7.758-3.26a.37.37 0 0 0 .223-.338zm-9.326 12.86v-9.506l-7.98-3.354v9.262c0 .147.087.28.222.337zm-.382-18.09a2.72 2.72 0 0 1 2.11 0l8.53 3.585c.252.106.415.353.415.627v10.28c0 .696-.415 1.323-1.051 1.59l-8.69 3.653a.67.67 0 0 1-.518 0l-8.69-3.652A1.72 1.72 0 0 1 2 16.705V6.425c0-.274.163-.521.414-.627z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }